import { useRef, useEffect } from 'react';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Fade from "react-reveal/Fade"
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

export default function Home(){
    
    const [mostraSezione1, setMostraSezione1] = useState(false);
    const [mostraSezione2, setMostraSezione2] = useState(false);
    const iframeRef = useRef(null);

    // Funzione per cambiare lo stato e invertire la visibilità della sezione
    const toggleSezione = () => {
        setMostraSezione1(!mostraSezione1);
    };
    const toggleSezione2 = () => {
        setMostraSezione2(!mostraSezione2);
    };

    const updateIframeHeight = () => {
        const iframe = iframeRef.current;
        if (iframe && mostraSezione1) {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          const height = iframeDoc.documentElement.scrollHeight;
          iframe.style.height = height + 'px';
        }
      };
    
      useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe) {
          iframe.style.height = '0px'; // imposta l'altezza iniziale dell'iframe a 0
    
          const updateHeight = () => {
            updateIframeHeight();
          };
    
          iframe.onload = updateHeight; // aggiorna l'altezza quando la pagina è caricata
          window.addEventListener('resize', updateHeight); // aggiorna l'altezza quando la finestra cambia dimensione
    
          return () => {
            window.removeEventListener('resize', updateHeight);
          };
        }
      }, [mostraSezione1]);

    


    return(
        <div className="container">
            
            <div className='riga'>
                <div className="paragrafo">
                    <Fade className="reveal-fade"><p id="#homep1">
                    La Protezione Civile è il coordinamento delle Azioni delle istituzioni, enti, corpi che intervengano in caso di eventi calamitosi, catostrofi, situazioni di emergenza. 
                    <br/><br/> La Protezione Civile è chiamata in campo all'insorgere di qualsivoglia situazione od evento che comporti o possa comportare a persone, beni, ambiente, grave danno o pericolo di grave danno,di natura ed estensione tale da dover essere fronteggiato con misure straordinarie.
                    <br/><br/>Il Centro Zeta, svolge attività antincendio, soccorso idrogeologico, interventi in caso di neve o ghiaccio, ricerca persone, attività di cartografia del territorio locale e pronto intervento per soccorso della poplazione.
                    </p></Fade>
                </div>
                <div className="image">
                    <Fade className="reveal-fade"><img src="/img/home1.jpeg" id="#home1" alt=""/></Fade>
                </div>              
            </div>
            <div className='riga'>               
                <div className="image">
                    <Fade className="reveal-fade"><img src="/img/home2.jpg" id="#home2" alt=""/></Fade>    
                </div>
                <div className="paragrafo">
                    <Fade className="reveal-fade"><p >
                    La persona che intende diventare "un Volontario di Protezione Civile" deve essere caratterizzata da un forte senso di altruismo e generosità nei confronti del prossimo.
                    <br/><br/>
                    Il Volontario di Protezione Civile devolve il suo tempo libero ad un valore in cui profondamente crede, traendo da questo una grande soddisfazione personale.
                    <br/>Per informazioni scriveteci a info@centrozeta.it
                    </p></Fade>
                </div>
                              
            </div>
                <button  onClick={toggleSezione2} className='ghost_button'><h2>
                        {mostraSezione2 ? 'Hai tempo libero? Ti piace la telecomunicazione? Vuoi fare Volontariato?' : 'Hai tempo libero? Ti piace la telecomunicazione? Vuoi fare Volontariato ?'} &nbsp; &nbsp;
                        {mostraSezione2 ? (
                        <FontAwesomeIcon icon={faChevronUp} />
                        ) : (
                        <FontAwesomeIcon icon={faChevronDown} />
                        )}{' '}
                        </h2>  
                </button>
                {mostraSezione2 && (
                    <div className='centrato'>
                        <div className='banner_cont'>
                            <img id="header2" src="/img/header2.gif"/>
                        </div>
                        <p>
                            Per essere un volontario si deve avere un minimo di tempo libero e tanta buona volontà, per partecipare attivamente nelle operazioni, il volontario sarà formato sotto i seguenti ambiti:
                        </p>
                        <ul>
                            <li>Corsi Antincendio con la Regione Lazio, con il Comune di Roma, o con gli organi preposti quali i Vigili del Fuoco.</li>
                            <li>Corsi teorici/pratici nell'uso delle Idrovore, Motopompe, Elettropompe.</li>
                            <li>Preparazione all'uso dei gruppi elettrogeni, come si usano, come si istalla una linea di alimentazione in un campo.</li>
                            <li>Montaggio di un campo, la disposizione delle tende e tutto ciò che serve per montare un campo funzionante.</li>
                            <li>Nozioni di cartografia e di comunicazione radio.</li>
                        </ul>
                        <p>Se desiderate partecipare anche voi a questa attività, e iscrivervi alla nostra associazione, potete visionare la seguente documentazione, e inviare la domanda di preiscrizione all'indirizzo e-mail: <b><a href="mailto:segreteria@centrozeta.it">segreteria@centrozeta.it</a></b>
                            <br></br>
                            Per qualsiasi informazioni, non esitate a contattarci.
                        </p>
                        <ul>
                            <li><a className='pdf' href="/pdf/regolamento.pdf" target="_blank">Regolamento interno</a></li>
                            <li><a className='pdf' href="/pdf/statuto.pdf" target="_blank">Statuto dell'associazione</a></li>
                            <li><a className='pdf' href="/pdf/domanda.pdf" target="_blank">Domanda di preiscrizione</a></li>
                        </ul>
                        <div className='banner_cont'>
                            <img className='banner'src='/img/volontario.png'/>
                        </div>
                    </div>
                        
                    
                )}
            <div>
                <button id="pulsante" onClick={toggleSezione} className='ghost_button'><h2>
                {mostraSezione1 ? 'Pubblicazione dei finanziamenti pubblici' : 'Pubblicazione dei finanziamenti pubblici'} &nbsp; &nbsp;
                    {mostraSezione1 ? (
                    <FontAwesomeIcon icon={faChevronUp} />
                    ) : (
                    <FontAwesomeIcon icon={faChevronDown} />
                    )}{' '}
                    </h2>  
                </button>
                {mostraSezione1 && (
                    <div className='ghost_div'>
                        <iframe
                        ref={iframeRef}
                        src="pdf.html" // Sostituisci con l'URL dell'iframe
                        frameBorder="0"
                        scrolling="no"
                        title="pdf"
                        
                        ></iframe>
                    </div>
                        
                    
                )}
            </div>
        </div>
    );
}